/**
 * @file: context.tsx
 *
 * The app-wide chat session context. Provided by `ChatSessionProvider`
 * (see `./provider`) and read via `useChatSession()`.
 */

import { createContext, useContext } from 'react';
import { ChatSessionContextProps } from '../types';

export const ChatSessionContext = createContext<ChatSessionContextProps>(
  null as any,
);

export const useChatSession = (): ChatSessionContextProps =>
  useContext(ChatSessionContext);
